// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Clipboard } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconClipboard(props: any) {
    return <IconBase icon={Clipboard} {...props} />
  }

  export default IconClipboard
  